
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form10";
const form10State = namespace("Form10");

import { form10DataInfoType } from '@/types/Information/Form10';

import Form10Layout from "./Form10Layout.vue";
import moment from 'moment';

@Component({
    components:{        
        Form10Layout
    }
})
export default class Form10 extends Vue {

    @Prop({required: true})
    caseId!: string;
    
    @form10State.State
    public currentOrderSingleJusticeId: string;

    @form10State.State
    public form10Info!: form10DataInfoType;

    @form10State.Action
    public UpdateForm10Info!: (newForm10Info: form10DataInfoType) => void

    result = {} as form10DataInfoType;
    dataReady = false;
    printReady = false
   
    mounted(){
        this.dataReady = false;
        this.printReady = false;
        this.getForm10Data(); 
    }   
           
    public onPrint() { 
        const pdf_type = "FORM"
        const pdf_name = "form10-" + this.caseId;
        const el= document.getElementById("print");
        
        const topLeftText    = `"COURT OF APPEAL FOR BRITISH COLUMBIA                              FORM 10: ORDER OF A SINGLE JUSTICE"`;
        const topRightText   = `"(Rule 66(3)(a) )"`;

        const bottomLeftText = `"COURT OF APPEAL FOR BRITISH COLUMBIA                              FORM 10: ORDER OF A SINGLE JUSTICE  (Rule 66(3)(a) )"`;
        const bottomRightText = `" "`;
                
        const url = '/form10/form-print/'+this.caseId+'/?name=' + pdf_name + '&pdf_type='+pdf_type+'&version=1.0&noDownload=true'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText, topLeftText, topRightText);

        const body = {
            'html':pdfhtml,
            'json_data':this.result
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {                       
            this.printReady = true;
            this.$emit('pdfReady')
        },err => {
            console.error(err);        
        });
    }

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form10"
        const url = '/form10/form-print/'+this.caseId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }

    public navigateToEditPage() {
        this.$router.push({name: "fill-form10" })
    }

    public navigateToSubmitPage(){
        this.$emit('navigateToSubmitPage')
    }
 
    public getForm10Data() {        

        this.result = this.form10Info;
       
        this.$http.get('/form10/forms/'+this.currentOrderSingleJusticeId)
        .then((response) => {
            if(response?.data?.data){            
                            
                this.result = response.data.data
                this.UpdateForm10Info(this.result)                         
                this.dataReady = true;
                Vue.nextTick(()=> this.onPrint())
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    // public onPrintSave() { 
    //     const pdf_type = "FORM"
    //     const pdf_name = "form10-" + this.currentOrderSingleJusticeId
    //     const el= document.getElementById("print");
      
    //     const bottomLeftText = `"COURT OF APPEAL FOR BRITISH COLUMBIA                    www.bccourts.ca/Court_of_Appeal/"`;
    //     const bottomRightText = `" "`;        
    //     const url = '/form10/form-print/'+this.currentOrderSingleJusticeId+'/?name=' + pdf_name + '&pdf_type='+pdf_type+'&version=1.0'
    //     const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );

    //     const body = {
    //         'html':pdfhtml,
    //         'json_data':this.result
    //     }       
        
    //     const options = {
    //         responseType: "blob",
    //         headers: {
    //         "Content-Type": "application/json",
    //         }
    //     }  

    //     this.$http.post(url,body, options)
    //     .then(res => {                       
    //         const blob = res.data;
    //         const link = document.createElement("a");
    //         link.href = URL.createObjectURL(blob);
    //         document.body.appendChild(link);
    //         link.download = "Form10.pdf";
    //         link.click();
    //         setTimeout(() => URL.revokeObjectURL(link.href), 1000); 
    //     },err => {
    //         console.error(err);        
    //     });
    // }
}
